export default (notification, course, room, myResources) => {
  let message = null;
  const type = notification.notificationType;
  const resource = notification.resourceType;
  const username = notification.fromUser ? notification.fromUser.username : '';
  // @todo refactor switch statements\
  if (type === 'requestAccess') {
    message = `${username} is requesting to join ${resource} ${
      myResources[`${resource}s`][notification.resourceId]
        ? myResources[`${resource}s`][notification.resourceId].name
        : '<name not found>'
    }`;
  } else if (type === 'grantedAccess') {
    message = `Votre demande d'adhésion à${resource} ${
      resource === 'room' ? room.name : course.name
    } a été accepté`;
  } else if (type === 'newMember') {
    message = `${username} joined ${resource} ${
      myResources[`${resource}s`][notification.resourceId]
        ? myResources[`${resource}s`][notification.resourceId].name
        : '<name not found>'
    } `;
  } else if (type === 'invitation') {
    message = `Vous avez été invité à rejoindre ${resource} ${
      resource === 'room' ? room.name : course.name
    }`;
  } else if (type === 'assignedNewRoom') {
    message = `${username} vous a attribué la salle ${room.name}`;
  }
  return message;
};



// WEBPACK FOOTER //
// ./src/Components/HOC/socketProvider.utils.js